export const routerKeys = {
	root: () => '/',
	cabinet: {
		root: () => `${routerKeys.root()}cabinet`,
		admin: {
			root: () => `${routerKeys.cabinet.root()}/admin`,
			sections: {
				root: () => `${routerKeys.cabinet.admin.root()}/sections`,
				section: (id: string) => `${routerKeys.cabinet.admin.sections.root()}/${id}`,
			},
			settings: {
				root: () => `${routerKeys.cabinet.admin.root()}/settings`,
			},
			users: {
				root: () => `${routerKeys.cabinet.admin.root()}/users`,
			},
		},
		errors: {
			root: () => `${routerKeys.cabinet.root()}/errors`,
		},
	},
	tabel: {
		root: () => `${routerKeys.root()}tabel`,
		roles: () => `${routerKeys.tabel.root()}/roles`,
		period: () => `${routerKeys.tabel.root()}/period`,
		rounding: () => `${routerKeys.tabel.root()}/rounding`,
		addUser: () => `${routerKeys.tabel.root()}/add-user`,
		limits: () => `${routerKeys.tabel.root()}/limits`,
		attendance: (userId?: number | string) =>
			userId === undefined
				? `${routerKeys.tabel.root()}/attendance`
				: `${routerKeys.tabel.root()}/attendance/${userId}`,
	},
	manager: {
		root: () => `${routerKeys.root()}manager`,
		add: () => `${routerKeys.manager.root()}/add`,
		end: (id: string) => `${routerKeys.manager.root()}/end/${id}`,
	},
	session: () => '/session',
	pinCodes: () => '/pin-codes',
	device: {
		root: () => '/device',
		byNumber: (number: string) => `${routerKeys.device.root()}/${number}`,
	},
	page404: () => '/404',
	denied: () => '/denied',
};
